import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DteSystemStatusDTO } from "../../../types/dte/system/DteSystemTypes";

interface DteSystemState {
  form: DteSystemStatusDTO | null;
  isLoading: boolean;
  isSubmitting: boolean;
  error: string | null;
}

const initialState: DteSystemState = {
  form: null,
  isLoading: false,
  isSubmitting: false,
  error: null,
};

const dteSystemSlice = createSlice({
  name: "dteSystem",
  initialState,
  reducers: {
    setDteSystemLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },

    setDteSystemSubmitting(state, action: PayloadAction<boolean>) {
      state.isSubmitting = action.payload;
    },

    setDteSystemError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    setDteSystemStatus(state, action: PayloadAction<DteSystemStatusDTO | null>) {
      state.form = action.payload; 
      state.error = null;
    },

    resetDteSystemState(state) {
      state.form = null;
      state.isLoading = false;
      state.isSubmitting = false;
      state.error = null;
    },
  },
});

export const {
  setDteSystemLoading,
  setDteSystemSubmitting,
  setDteSystemError,
  setDteSystemStatus,
  resetDteSystemState,
} = dteSystemSlice.actions;

export default dteSystemSlice.reducer;
